var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatticeAlt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5599 127.249L20.6973 99.2553C15.9629 94.4986 8.28681 94.4986 3.55084 99.2553C-1.18361 104.012 -1.18361 111.724 3.55084 116.482L39.9867 153.09C44.7212 157.847 52.3988 157.847 57.1329 153.09L91.4276 118.633L74.2828 101.405L48.5599 127.249Z",
    fill: "#16B8A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.582 73.418L100.004 127.248L46.4201 73.412C41.6842 68.6537 34.0081 68.6537 29.2736 73.412C24.5392 78.1687 24.5392 85.881 29.2736 90.6392L91.431 153.089C96.1651 157.846 103.841 157.846 108.577 153.089L170.728 90.6453C175.463 85.887 175.463 78.1748 170.728 73.418C165.992 68.6613 158.316 68.6613 153.582 73.418Z",
    fill: "#FFB41F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.449 116.487L160.019 153.088C155.284 157.845 147.608 157.845 142.874 153.088L54.9943 64.7944C50.2599 60.0377 50.2599 52.3255 54.9943 47.5687C59.7301 42.8104 67.4062 42.8104 72.1408 47.5687L151.446 127.248L179.302 99.2596C184.038 94.5029 191.714 94.5029 196.449 99.2596C201.184 104.018 201.184 111.73 196.449 116.487Z",
    fill: "#F56358"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.006 47.5759C140.272 42.8191 132.596 42.8191 127.86 47.5759L74.2817 101.406L91.4282 118.633L145.006 64.8031C149.74 60.0449 149.74 52.3326 145.006 47.5759Z",
    fill: "#16B8A2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatticeAlt2);
export default __webpack_public_path__ + "static/media/lattice-alt2.b38a096fc2fc39eb1d5e61db24959c86.svg";
export { ForwardRef as ReactComponent };